module.exports = __webpack_public_path__ + "static/media/VectorPointAndamento11.43aa318f.svg";